export default [
  {
    dataId: 1,
    name: 'Travel',
    value: 400,
  },
  {
    dataId: 2,
    name: 'Bill',
    value: 300,
  },
  {
    dataId: 3,
    name: 'Groceries',
    value: 500,
  },
  {
    dataId: 4,
    name: 'Salary',
    value: 200,
  },
];
